// 图片路径配置文件
// 集中管理项目中使用的所有图片路径，方便统一修改和维护

const imagePath = {
  //每月运营总结
  img1: "https://lingxin1314.oss-cn-beijing.aliyuncs.com/weixiaozhu/AI_back2.png",

  // 二维码图片
  qrcodeService: require("../assets/qrcode_service.png"),
  qrcodeWebsite: require("../assets/qrcode_website.png"),

  // 轮播图
  swiper1: require("../assets/swiper1.png"),
  swiper2: require("../assets/swiper2.png"),
  // 用于测试的变量图片
  ceshiImage:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/01/20/2026-01-20MC14:48:2191bf05e196af41889805554aff6f26ca.png",
  // 通知公告子组件右侧面板区域图标
  noticeImage1:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/01/15/2026-01-15MC10:16:39fe185f84ae884625927724f2cb0726f4.png",
  noticeImage2:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/01/15/2026-01-15MC10:23:486fee8e689f884066b761501233fb8172.png",
  noticeImage3:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/01/15/2026-01-15MC10:24:2117d13b77623145619554ef488f70d4f8.png",
  noticeImage4:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/01/15/2026-01-15MC10:24:52f2272606ef0046d6ada008184cc16afa.png",
  noticeImage5:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/01/15/2026-01-15MC10:25:069f7e168c89f746888fe81e297056a374.png",
  noticeImage6:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/01/15/2026-01-15MC10:25:20bfcd13d51df04582bbdf5509014c55bb.png",
  // 可以根据需要添加更多分类
  // 例如：homeImages, productImages, iconImages 等
  homeImage1:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/01/16/2026-01-16MC15:39:3282ee5e1607184931be94bcee79d7a8ac.png",
  icon0:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/01/23/2026-01-23MC09:32:07990cfc429c914201b1c3b906eaabaa82.png",
  image0:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/01/16/2026-01-16MC16:19:32da996d5091e44d23ae54a75eefb28c29.png",
  image1:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/01/16/2026-01-16MC16:20:1416ed8203c14243f7b62fc1fb26d08cde.png",
  image2:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/01/16/2026-01-16MC16:20:46db4b8d218554445a9e4a9b191cc199c6.png",
  image3:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/01/16/2026-01-16MC16:21:26847e5c4f1bad46239bf21acf3c1106d9.png",
  image4:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/01/21/2026-01-21MC13:10:486ee3782c446f414185b3885a2cadc400.png",
  image5:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/01/21/2026-01-21MC13:11:467e8692923fc24f1b929104876b83649d.png",
  image6:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/01/21/2026-01-21MC13:12:1378cb6f6da24744ff8558317c17c1b65e.png",
  image7:
    "https://p1.itc.cn/q_70/images03/20231212/59ca642ed7694505ab810c1781b4bb10.png",
  image8:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/01/21/2026-01-21MC13:18:1586a724d47cd74d78af224a53e189e3e6.png",
  image9:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/01/21/2026-01-21MC13:18:51160b39a25b1d4e1e9497b3ab5e4c2164.png",
  image10:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/01/21/2026-01-21MC13:19:149a4dff3d0b4b412892d087f4e3b94a77.png",
  // 互动卡片组件库模块样式图片
  image11:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/01/21/2026-01-21MC16:06:10b1a258e298cc479c872c375b8f9dd152.png",
  image13:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/01/21/2026-01-21MC16:20:28e0321cab6bf94c4dac8435caccc415f5.png",
  image14:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/01/21/2026-01-21MC16:21:50d18b1f454ece444f967ca8987d77ea78.png",
  // 文章列表组件库模块样式图片
  image15:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/01/22/2026-01-22MC14:29:26e8669ca027394bf9af325d96377a2a46.png",
  image16:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/01/22/2026-01-22MC14:30:028e785af8782744aaba24c9d69d444847.png",
  image17:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/01/22/2026-01-22MC14:30:251fe0fde1d69e4f7ab733f706efec2b4e.png",
  // 无图片显示图片
  imageNone:
    "https://lingxin1314.oss-cn-beijing.aliyuncs.com/weixiaozhu/no-pic2.jpg",
  // 横向标签组件模块样式图片
  image18:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/01/28/2026-01-28MC16:08:39a576d611c380441e9d847b3d19611385.png",
  image19:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/01/28/2026-01-28MC16:13:136a9f126bdb334f44bf0bf16c83dd0506.png",
  image20:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/01/28/2026-01-28MC16:14:1405f1e2e6566840519935f259e211d216.png",
  image21:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/01/28/2026-01-28MC16:15:3922e93d590c254d2b9c9754f1fdcd8738.png",
  // 搜索组件模块样式图片
  image22:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/02/02/2026-02-02MC15:55:24aac92397fd1f4e0b97fb05d0514ded58.png",
  image23:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/02/02/2026-02-02MC15:56:344022b8a740944516b0ebb182d8d425e5.png",
  // 通知公告模块样式图片
  image24:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/02/02/2026-02-02MC16:26:21b8c51632ad974b02bff62157d278ef7c.png",
  image_icon24:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/02/03/2026-02-03MC09:49:310d1628c15b1b43959d8f78099ef26ecc.png",
  image25:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/02/02/2026-02-02MC16:27:08111ae0c7c10640aaa3381bb36f3febd6.png",
  image_icon25:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/02/03/2026-02-03MC09:58:02c389b497ec0b446d92ebf24ad9b2f3d9.png",
  image26:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/02/02/2026-02-02MC16:27:337857a9b1130141fa85901bb46a97f284.png",
  image_icon26:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/02/03/2026-02-03MC09:59:31f0e6da40e1604b26a2c06ee7dac433c6.png",
  image27:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/02/02/2026-02-02MC16:33:50615ad11911004120a3121c18be92d860.png",
  image_icon27:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/02/03/2026-02-03MC10:00:14e633ef2b1c5043fbac4503e9ff8371c0.png",
  image28:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/02/02/2026-02-02MC16:28:30d501c61cdc6c43f6a6990a74fe490b60.png",
  image_icon28:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/02/03/2026-02-03MC10:01:001774d24f96e4484d9b0df04643d76163.png",
  image29:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/02/02/2026-02-02MC16:30:12106bd54bcfa74f7d9414ae0869245c84.png",
  image_icon29:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/02/03/2026-02-03MC10:13:18948489ecee5d413189e7e917e9b8d715.png",

  // 详情模块样式图片
  image30:
    "https://mo.faisys.com/image/styleDesign/richpic05.jpg?v=201406201658",
  image31:
    "https://mo.faisys.com/image/styleDesign/richpic08.jpg?v=201406201658",
  // 公众号管理-基本信息
  image32:
    "http://tb953h9nq.hn-bkt.clouddn.com/uploads/1772522278_6umkk1.png?e=1772522585&token=gGqc6parldhDM4pgQzc3pHDQsmItD-_Nn0MqcEoW:8l6VgxHOMR0TVEjx9Ms0tgSwLJ4=",
  // 推文-AI生文导航图片
  image33:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/03/25/2026-03-25MC10:03:328709c04ec7334087ba6acb5bf295bca3.png",
  image_icon_1_33:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/03/25/2026-03-25MC11:22:226feac31b02194ea0bd065dcbad37d8be.png",
  image_icon_2_33:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/03/25/2026-03-25MC11:25:3241215a6e16f847f8a70251d24545096e.png",
  image_icon_3_33:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/03/25/2026-03-25MC11:32:47441ebad488d2481d8af1b491dc65fc24.png",
  image_icon_3_33:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/03/25/2026-03-25MC11:33:43c54ac085a4a2409aa40fe12930f88762.png",

  // 模块-魔方导航组件库相关图标
  // 模块样式1图标
  //企业简介
  image34_1:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/05/27/2026-05-27MC11:46:25ee8a7d4a40564e82af4820b15ee7514d.png",
  //案例展示
  image34_2:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/05/27/2026-05-27MC11:47:5182b84ba340b74a488ef012946c6ac9be.png",
  //品牌介绍,
  image34_3:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/05/27/2026-05-27MC11:49:0550b8598e10de4b51a8b91d308216429e.png",
  //资讯服务
  image34_4:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/05/27/2026-05-27MC11:50:08c78c972338ce400eb5b25548a901b49e.png",
  //福利活动
  image34_5:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/05/27/2026-05-27MC11:50:4343be2bcdf1bb456287a04e0f2e629a69.png",
  //在线预约
  image34_6:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/05/27/2026-05-27MC11:51:2795c5bc046f0e4e47ad66d3f98fe0db9c.png",
  //留言反馈
  image34_7:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/05/27/2026-05-27MC11:52:043b282b59341846c2ab4ad904028a3ff2.png",
  //联系我们
  image34_8:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/05/27/2026-05-27MC11:52:362e15b1bc1eb14a27b1fa323706ecfe32.png",

  // 模块样式2图标
  // 企业简介
  image35_1:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/05/27/2026-05-27MC11:53:59ac654c30803c4a779c732abce04b2f55.png",
  //在线预约
  image35_2:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/05/27/2026-05-27MC11:54:485fa3e322229244a989e711b0200fdf24.png",
  //案例展示
  image35_3:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/05/27/2026-05-27MC13:04:46f59c88eef74d4b7d88a185e8f76969f1.png",
  //联系我们
  image35_4:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/05/27/2026-05-27MC13:06:332a79d3f5210f42cbb54e8251c6afa880.png",
  //模块样式3图标 和模块样式2图标用一个
  // 模块样式4图标
  // 企业简介
  image36_1:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/05/27/2026-05-27MC13:10:45a083a8d507254962ac9fa3ddd840cbb0.png",
  // 联系我们
  image36_2:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/05/27/2026-05-27MC13:11:38aa72524908594fc498e68f5b0a38dd97.png",
  //案例展示
  image37_3:
    "https://youejoyjt-wxz.oss-cn-beijing.aliyuncs.com/pic-images/2026/05/27/2026-05-27MC13:12:397327bb652b194f4ea3f18e8f973bc90b.png",
};

// 导出图片路径配置
export default imagePath;
